<template>
  <v-layout row justify-center>
    <v-dialog
      v-model="dialog"
      fullscreen
      transition="dialog-bottom-transition"
      :overlay=false
      scrollable
      style="z-index:200000"
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue-grey">
          <v-toolbar-title>ユーザー情報入力</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-list three-line subheader>
            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title>まず初めに</v-list-tile-title>
                <v-list-tile-sub-title>新郎新婦様のお名前、挙式日、メールアドレスのご入力をお願いいたします。</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-divider></v-divider>
          <v-list three-line subheader>
            <v-subheader>ご入力欄</v-subheader>
            <v-form ref="form" @submit.prevent="submit">
              <v-container grid-list-xl fluid>
                <v-layout wrap>
                  <v-flex xs12 sm6>
                    <v-text-field
                      v-model="form.name1"
                      :rules="rules.name"
                      color="blue darken-2"
                      label="【新郎】姓"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      v-model="form.name2"
                      :rules="rules.name"
                      color="blue darken-2"
                      label="【新郎】名"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      v-model="form.kana01"
                      :rules="rules.name"
                      color="blue darken-2"
                      label="【新郎】フリガナ（セイ）"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      v-model="form.kana02"
                      :rules="rules.name"
                      color="blue darken-2"
                      label="【新郎】フリガナ（メイ）"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      v-model="form.name1_2"
                      :rules="rules.name"
                      color="pink darken-1"
                      label="【新婦】姓"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      v-model="form.name2_2"
                      :rules="rules.name"
                      color="pink darken-1"
                      label="【新婦】名"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      v-model="form.kana01_2"
                      :rules="rules.name"
                      color="pink darken-1"
                      label="【新婦】フリガナ（セイ）"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      v-model="form.kana02_2"
                      :rules="rules.name"
                      color="pink darken-1"
                      label="【新婦】フリガナ（メイ）"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs11 sm5>
                    <v-menu
                      lazy
                      :close-on-content-click="false"
                      v-model="menu"
                      transition="scale-transition"
                      offset-y
                      full-width
                      :nudge-right="40"
                      max-width="290px"
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        :rules="rules.date"
                        label="挙式日"
                        v-model="form.dateFormatted"
                        prepend-icon="event"
                        @blur="date = parseDate(form.dateFormatted)"
                        readonly
                      ></v-text-field>
                      <v-date-picker v-model="date" @input="menu = false" locale="jap" no-title scrollable actions></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="form.email1"
                      :rules="emailRules"
                      color="teal"
                      label="新郎メールアドレス"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="form.email2"
                      :rules="emailRules"
                      color="teal"
                      label="新婦メールアドレス"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <p>ご利用規約にご同意ください。</p>
                    <v-checkbox
                      v-model="form.terms"
                      color="green"
                    >
                      <div slot="label">
                        <a href="javascript:;" @click.stop="terms = true">ご利用規約</a>
                      </div>
                    </v-checkbox>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-card-actions>
                <v-btn flat @click="resetForm">リセット</v-btn>
                <v-btn
                  :disabled="!formIsValid"
                  color="primary"
                  type="submit"
                >決定</v-btn>
              </v-card-actions>
            </v-form>
            <v-dialog v-model="terms" width="70%">
              <v-card>
                <v-card-title class="title">ご利用規約</v-card-title>
                <v-card-text>
                  <agreement-body/>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    flat
                    color="purple"
                    @click="terms = false"
                  >Ok</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-list>
        </v-card-text>
        <div style="flex: 1 1 auto; height:100px;"></div>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import UserService from '@/components/services/UserService.vue'
import AgreementBody from '@/components/AgreementBody.vue'
export default {
  name: 'InitialInput',
  components: {
    AgreementBody
  },
  data () {
    const defaultForm = Object.freeze({
      name1: this.$store.getters.getGroomLastName,
      name2: this.$store.getters.getGroomFirstName,
      kana01: this.$store.getters.getGroomLastNameKana,
      kana02: this.$store.getters.getGroomFirstNameKana,
      name1_2: this.$store.getters.getBrideLastName,
      name2_2: this.$store.getters.getBrideFirstName,
      kana01_2: this.$store.getters.getBrideLastNameKana,
      kana02_2: this.$store.getters.getBrideFirstNameKana,
      email1: this.$store.getters.getGroomEmail,
      email2: this.$store.getters.getBrideEmail,
      dateFormatted: this.$store.getters.getWeddingDate
    })

    return {
      dialog: false,
      date: null,
      menu: false,
      form: Object.assign({}, defaultForm),
      rules: {
        name: [val => (val || '').length > 0 || 'この項目は必須です。'],
        date: [val => (val || '').length > 0 || 'この項目は必須です。']
      },
      emailRules: [
        v => !!v || 'この項目は必須です。',
        v => /.+@.+/.test(v) || 'メールアドレスの形式で入力して下さい。'
      ],
      sendContact: false,
      terms: false,
      defaultForm
    }
  },
  computed: {
    formIsValid () {
      return (
        this.form.name1 &&
        this.form.name2 &&
        this.form.kana01 &&
        this.form.kana02 &&
        this.form.name1_2 &&
        this.form.name2_2 &&
        this.form.kana01_2 &&
        this.form.kana02_2 &&
        this.form.email1 &&
        this.form.email2 &&
        this.form.dateFormatted &&
        this.form.terms
      )
    }
  },
  watch: {
    date (val) {
      this.form.dateFormatted = this.formatDate(this.date)
    }
  },

  mounted () {
    setTimeout(() => {
      this.dialog = true
    }, 3100)
  },

  methods: {
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${year}/${month}/${day}`
    },
    parseDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    resetForm () {
      this.form = Object.assign({}, this.defaultForm)
      this.$refs.form.reset()
    },
    submit () {
      this.updateCustomerInfo()
      this.sendContact = true
      // this.resetForm()
      // this.dialog = false
    },
    /**
     * 新郎新婦情報の更新
     **/
    updateCustomerInfo () {
      this.$log.debug('methods: updateCustomerInfo START')
      let params = new URLSearchParams()
      params.append('transactionid', this.$store.state.transactionId)
      params.append('wedding_date', this.form.dateFormatted)
      params.append('name01', this.form.name1)
      params.append('name02', this.form.name2)
      params.append('kana01', this.form.kana01)
      params.append('kana02', this.form.kana02)
      params.append('name01_2', this.form.name1_2)
      params.append('name02_2', this.form.name2_2)
      params.append('kana01_2', this.form.kana01_2)
      params.append('kana02_2', this.form.kana02_2)
      params.append('email', this.form.email1)
      params.append('email_bride', this.form.email2)
      UserService.updateCustomerInfo(params, (response) => {
        if (response.status >= 200) {
          this.$log.debug('updateCustomerInfo', response)
          let formData = new URLSearchParams()
          formData.append('transactionid', this.$store.state.transactionId)
          UserService.logout(formData, (response) => {
            if (response.success) {
              // ログアウト処理
              this.$store.commit('resetState')
              this.$router.push('/register-confirm')
            }
          }, (error) => {
            this.$log.error(error)
          })
        }
      }, (error) => {
        this.$log.error(error)
      })
      this.$log.debug('methods: updateCustomerInfo END')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/InitialInput.vue